var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDimingControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4057 26.4846L15.0514 49.9315C15.0055 50.0187 14.9303 50.0869 14.839 50.124C14.7478 50.1611 14.6463 50.1648 14.5526 50.1345C14.4589 50.1041 14.3789 50.0416 14.3267 49.9581C14.2745 49.8745 14.2535 49.7752 14.2674 49.6777L17.2944 28.4067L3.79216 29.5615C3.75986 29.5643 3.7274 29.5583 3.69818 29.5443C3.66897 29.5302 3.64407 29.5085 3.62608 29.4816C3.6081 29.4546 3.5977 29.4233 3.59596 29.3909C3.59423 29.3585 3.60122 29.3263 3.61621 29.2975L17.9978 1.7049C18.0434 1.61751 18.1183 1.54901 18.2094 1.51149C18.3006 1.47396 18.402 1.46982 18.4959 1.49979C18.5898 1.52976 18.67 1.59192 18.7226 1.67531C18.7751 1.75869 18.7965 1.85794 18.7829 1.95556L15.8386 23.2203L23.6239 22.0374",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4458 28.6909C41.1042 28.6909 46.502 23.2932 46.502 16.6348C46.502 9.97634 41.1042 4.57861 34.4458 4.57861C27.7874 4.57861 22.3896 9.97634 22.3896 16.6348C22.3896 23.2932 27.7874 28.6909 34.4458 28.6909Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4922 15.3269L40.3943 10.4248",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3895 18.6252C35.3882 18.6252 36.1979 17.8155 36.1979 16.8167C36.1979 15.818 35.3882 15.0083 34.3895 15.0083C33.3907 15.0083 32.5811 15.818 32.5811 16.8167C32.5811 17.8155 33.3907 18.6252 34.3895 18.6252Z",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281 0.817383)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimingControl);
export default __webpack_public_path__ + "static/media/Diming-control.242b20a09cc206984fc37e69720fe0be.svg";
export { ForwardRef as ReactComponent };